export class TableCategoryLinkColumnDTO {
  linkColor: 'primary' | 'warn'
  linkText: string
}
